module.exports = __webpack_public_path__ + "img/xueqianjiaoyuzhuanyeziyuanku.60456295.png";